<template>
  <div class="brand-pub-wrap">
    <template v-for="(item, index) in pageContent">
      <div
        :key="index"
        class="mode-wrap"
        v-if="item.isShow === 1"
        :class="{
          paddingTop0: typeArray.includes(item.tempType),
          width100: item.tempType === 'HOMEPAGE_TYPE_PUBLICITY' && !pHeaderStyle1or3,
        }"
      >
        <!-- tempType
        1 HOMEPAGE_TYPE_PUBLICITY 宣传模块
        2 HOMEPAGE_TYPE_SPECIAL 特色模块
        3 HOMEPAGE_TYPE_BANNER 品牌介绍模块 ？长Banner图
        4 HOMEPAGE_TYPE_GAME_SHOW 游戏展示
        5 体育展示
        6 HOMEPAGE_TYPE_CAROUSEL 轮播图
        7 HOMEPAGE_TYPE_MARQUEE 跑马灯
        8 游戏画面
        9 HOMEPAGE_TYPE_NAV 导航栏
        10 HOMEPAGE_TYPE_BRAND_SHOW 厂商展示
        11 HOMEPAGE_TYPE_JP_SHOW JP展示
        12 最新投注和赛事
        HOMEPAGE_TYPE_GAME_SEARCH: 搜索模块, 仅h5
        HOMEPAGE_TYPE_GAME_LATEST: 历史游戏,
        13 HOMEPAGE_TYPE_GAME_LUCKY: 幸运游戏,
        15 HOMEPAGE_TYPE_RICH_TEXT: 富文本,
        20 HOMEPAGE_TYPE_EMAIL_SHOW 邮件展示
        -->
        <Mode1
          v-if="item.tempType === 'HOMEPAGE_TYPE_PUBLICITY'"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />

        <Mode2
          v-if="item.tempType === 'HOMEPAGE_TYPE_SPECIAL'"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
        <Mode3
          v-if="item.tempType === 'HOMEPAGE_TYPE_BANNER'"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
        <Mode4
          v-if="item.tempType === 'HOMEPAGE_TYPE_GAME_SHOW'"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
        <Mode5
          v-if="item.tempType === 'HOMEPAGE_TYPE_SPORT_SHOW'"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
        <HBanner
          v-if="item.tempType === 'HOMEPAGE_TYPE_CAROUSEL'"
          :curindex="index"
          :item="item"
          :skeletonLoading="skeletonLoading"
        />
        <Mode7
          v-if="item.tempType === 'HOMEPAGE_TYPE_MARQUEE'"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
        <!-- <Mode8 v-if="item.tempType === 8" :item="item" :curindex="index" :skeletonLoading="skeletonLoading" /> -->
        <Mode9
          v-if="item.tempType === 'HOMEPAGE_TYPE_NAV'"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
        <Mode10
          v-if="item.tempType === 'HOMEPAGE_TYPE_BRAND_SHOW'"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />

        <Mode11
          v-if="item.tempType === 'HOMEPAGE_TYPE_JP_SHOW'"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
        <!-- 历史游戏 -->
        <Mode4
          v-if="item.tempType === 'HOMEPAGE_TYPE_GAME_LATEST' && getToken"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
        <!-- 幸运游戏 -->
        <Mode13
          v-if="item.tempType === 'HOMEPAGE_TYPE_GAME_LUCKY' && getToken"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
        <!-- 新人充值 -->
        <Mode14
          v-if="item.tempType === 'HOMEPAGE_TYPE_NEW_USER_RECHARGE' && getToken"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
        <!-- 富文本 -->
        <Mode15
          v-if="item.tempType === 'HOMEPAGE_TYPE_RICH_TEXT'"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
        <!-- 视讯 -->
        <Mode16
          v-if="item.tempType === 'HOMEPAGE_TYPE_VIDEO_GAME_SHOW'"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
        <!-- 体育资讯 -->
        <Mode17
          v-if="item.tempType === 'HOMEPAGE_TYPE_SPORTS_CONSULTING'"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
        <!-- 下载模板 -->
        <Mode18
          v-if="item.tempType === 'HOMEPAGE_TYPE_DOWNLOAD'"
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
        <!-- 免费金币 -->
        <Mode19
          v-if="
            item.tempType === 'HOMEPAGE_TYPE_SPORTS_WITHDRAW_FREE_COINS' &&
            getToken &&
            isNewWithdrawMode &&
            userFreeAmount > 0
          "
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
        <!-- 邮件展示 HOMEPAGE_TYPE_EMAIL_SHOW -->
        <Mode20
          v-if="
            item.tempType === 'HOMEPAGE_TYPE_EMAIL_SHOW' &&
            getToken && hasUnreceivedNotice
          "
          :item="item"
          :curindex="index"
          :skeletonLoading="skeletonLoading"
        />
      </div>
    </template>
    <div class="mode-wrap">
      <Mode12 :curindex="pageContent.length" />
    </div>
  </div>
</template>

<script>
// import HBanner from "@/components/banner/h-banner.vue";
import HBanner from "@/components/banner/h-banner-2500.vue";
import Mode1 from "@/views/homeModule/mode1.vue";
import Mode2 from "@/views/homeModule/mode2.vue";
import Mode3 from "@/views/homeModule/mode3.vue";
import Mode4 from "@/views/homeModule/mode4.vue";
import Mode5 from "@/views/homeModule/mode5.vue";
import Mode7 from "@/views/homeModule/mode7.vue";
// import Mode8 from "@/views/homeModule/mode8.vue";
import Mode9 from "@/views/homeModule/mode9.vue";
import Mode10 from "@/views/homeModule/mode10.vue";
import Mode11 from "@/views/homeModule/mode11.vue";
import Mode12 from "@/views/homeModule/mode12.vue";
import Mode13 from "@/views/homeModule/mode13.vue";
import Mode14 from "@/views/homeModule/mode14.vue";
import Mode15 from "@/views/homeModule/mode15.vue";
import Mode16 from "@/views/homeModule/mode16.vue";
import Mode17 from "@/views/homeModule/mode17.vue";
import Mode18 from "@/views/homeModule/mode18.vue";
import Mode19 from "@/views/homeModule/mode19.vue";
import Mode20 from "@/views/homeModule/mode20.vue";
// import { getHomepage } from "@/lobby_common/api/basic_gen.js";
import { getHomepageC as getHomepage, saveViceHomePage } from "@/lobby_common/api/cacheApi";
import { getHomepagePc } from "@/lobby_common/cdnApi/index.js";
import { setCacheData, getCacheData } from "@/lobby_common/utils/index.js";
export default {
  name: "brandPubWrap",
  components: {
    HBanner,
    Mode1,
    Mode2,
    Mode3,
    Mode4,
    Mode5,
    Mode7,
    // Mode8,
    Mode9,
    Mode10,
    Mode11,
    Mode12,
    Mode13,
    Mode14,
    Mode15,
    Mode16,
    Mode17,
    Mode18,
    Mode19,
    Mode20,
  },
  props: [],
  mixins: [],
  data() {
    return {
      pageContent: [],
      skeletonLoading: false,
      templateSid: "",
      typeArray: [
        "HOMEPAGE_TYPE_GAME_SHOW",
        "HOMEPAGE_TYPE_GAME_LATEST",
        "HOMEPAGE_TYPE_GAME_LUCKY",
        "HOMEPAGE_TYPE_NEW_USER_RECHARGE",
      ],
      // startTime: 0,
    };
  },
  filters: {},
  computed: {
    getUnreceivedNoticeObj() {  // 未领取邮件红点
      return this.$store.getters.getUnreceivedNotice || {};
    },
    hasUnreceivedNotice() {
      return this.getUnreceivedNoticeObj.unreceivedNotice
    },
    getToken() {
      return this.$store.getters.taken;
    },
    topNavigation() {
      // return { style: 3, menuPosition: 1 }
      return this.$store.getters.getPacketConfig?.topNavigationTemplate?.pc || null;
    },
    pHeaderStyle1or3() {
      return this.topNavigation?.style === 1 || this.topNavigation?.style === 3;
    },
    lang() {
      return this.$store.getters.getLang;
    },
    isNewWithdrawMode() {
      const withdrawMode = this.$store?.getters?.getPacketConfig?.appConfig?.withdrawMode;
      return withdrawMode === "WITHDRAW_MODE_FREE_GOLD";
    },
    getUserCoins() {
      return this.$store.getters.getUserCoins;
    },
    userCoins() {
      return (this.getUserCoins?.wallets || []).reduce((acc, item) => {
        acc[item.coinCode] = item;
        return acc;
      }, {});
    },
    userData() {
      return this.$store.getters.user || {};
    },
    userCoinCode() {
      return this.userData.coinCode;
    },
    userCoinCodeObj() {
      // 会员货币对象
      return this.userCoins[this.userCoinCode] || {};
    },
    userFreeAmount() {
      return this.userCoinCodeObj.experienceWallet ? Number(this.userCoinCodeObj.experienceWallet) : 0;
    },
  },
  watch: {
    "$route.query.templateSid": {
      handler(newVal, oldVal) {
        console.log("templateSid changed:", newVal);
        this.templateSid = newVal;
        this.getTemplate();
      },
      immediate: false,
    },
  },
  created() {
    // this.startTime = Date.now();
    this.templateSid = this.$route.query.templateSid || "";
    this.getTemplate();
  },
  mounted() {},
  methods: {
    // 获取内容配置
    async getTemplate() {
      const opt = {};
      let finalData = null;
      if (this.templateSid) {
        // 副首页
        opt.sid = this.templateSid;
        // 获取缓存数据
        const cacheData = await getHomepage(opt);
        if (cacheData && cacheData.pc) {
          finalData = cacheData;
        } else {
          // 接口
          const pcres = await getHomepagePc(opt);
          if (pcres.code === 0 && pcres.data?.pc) {
            finalData = pcres.data;
            saveViceHomePage(opt.sid, finalData);
          }
        }
      } else {
        // 正常首页
        let { code, data } = await getHomepage(opt);
        if (code === 0) {
          if (!data || !data.pc) {
            // 调用接口数据
            const pcres = await getHomepagePc(opt);
            console.log("data pc", pcres);
            if (pcres.code === 0 && pcres.data?.pc) {
              data = pcres.data;
              // 更新缓存
              try {
                const cacheData = getCacheData("homepage");
                if (cacheData?.data) {
                  setCacheData(
                    "homepage",
                    JSON.parse(
                      JSON.stringify({
                        ...cacheData?.data,
                        pc: data.pc,
                      })
                    )
                  );
                }
              } catch (error) {}
            }
          }
        }
        finalData = data;
      }

      const pageContent = JSON.parse(finalData.pc || "[]");
      this.pageContent = pageContent || [];

      this.pageContent.map((v) => {
        v.list = [];
        v.topLanguageMap = null;
        v.topLanguage = v.topLanguage ? JSON.parse(v.topLanguage) : [];
        v.topLanguage = v.topLanguage.filter((person) => person.language !== "");
        if (v.topLanguage && v.topLanguage.length > 0) {
          v.topLanguageMap = v.topLanguage.find((e) => e.language === this.lang) || null;
        }
        if (v.labels && Array.isArray(v.labels)) {
          v.list = [...v.labels];
          v.list.map((i) => {
            i.langInfoObj = {};

            if (i.languages && i.languages.length > 0) {
              i.languages.map((item) => {
                i.langInfoObj[item.language] = { ...item };
              });
            }
          });
          if (!v.topLanguageMap && v.topLanguage.length === 0) {
            v.topLanguageMap = v.labels[0]?.langInfoObj[this.lang] || v.labels[0]?.langInfoObj["en"] || null;
          }
        }
      });
      // this.skeletonLoading = false;
      this.$Bus.$emit("onSkeletonLoading", false);
      // setTimeout(() => (this.skeletonLoading = false), 1500);
      if (!opt.sid) {
        const endTime = Date.now();
        const duration = endTime - window.dateNow;
        console.log("============duration=============", endTime, duration);
        this.$eventPost("web_homeload_success", { time: duration });
      }
      console.log(this.pageContent, "this.pageContent", this.lang);
    },
  },
};
</script>
<style lang="scss" scoped>
// .brand-pub-wrap {

// }
.mode-wrap {
  padding: 0 35px;
  padding-top: 15px;
  max-width: 1340px;
  margin: 0 auto;
  box-sizing: border-box;
  &.width100 {
    max-width: 100%;
    padding: 0;
  }
  &.paddingTop0 {
    padding-top: 0px;
  }
}
.about-div {
  margin-bottom: 50px;
  img {
    width: 100%;
  }
}
</style>
